/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SummaryItemsFamilyTexts
 */
export interface SummaryItemsFamilyTexts {
  /**
   *
   * @type {string}
   * @memberof SummaryItemsFamilyTexts
   */
  etelCode?: string | null
  /**
   *
   * @type {string}
   * @memberof SummaryItemsFamilyTexts
   */
  familyText?: string | null
  /**
   *
   * @type {string}
   * @memberof SummaryItemsFamilyTexts
   */
  executionText?: string | null
}

/**
 * Check if a given object implements the SummaryItemsFamilyTexts interface.
 */
export function instanceOfSummaryItemsFamilyTexts(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function SummaryItemsFamilyTextsFromJSON(
  json: any,
): SummaryItemsFamilyTexts {
  return SummaryItemsFamilyTextsFromJSONTyped(json, false)
}

export function SummaryItemsFamilyTextsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SummaryItemsFamilyTexts {
  if (json === undefined || json === null) {
    return json
  }
  return {
    etelCode: !exists(json, 'EtelCode') ? undefined : json['EtelCode'],
    familyText: !exists(json, 'FamilyText') ? undefined : json['FamilyText'],
    executionText: !exists(json, 'ExecutionText')
      ? undefined
      : json['ExecutionText'],
  }
}

export function SummaryItemsFamilyTextsToJSON(
  value?: SummaryItemsFamilyTexts | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    EtelCode: value.etelCode,
    FamilyText: value.familyText,
    ExecutionText: value.executionText,
  }
}
